import { Link } from "react-router-dom";
import styled from "styled-components";

export const FolderList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  height: calc(100svh - 80px);
  width: 280px;
  background-color: #1a1a1a;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding: 0 1rem;
    padding-top: 1rem;
    width: 100%;
  }
`;

export const Container = styled.div`
  width: 280px;
  transition: width 0.3s ease-in-out;
  height: calc(100svh - 80px);
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Sidebar = styled.div`
  background-color: transparent;
  box-sizing: border-box;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;

export const Header = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: ${(props) => (props.isOpen ? "space-between" : "center")};
  height: 80px;
`;

export const Logo = styled.img`
  height: 24px;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  background-color: #333;
  border: none;
  border-radius: 6px;
  color: white;
  margin: 1rem 0;
`;

export const FolderItem = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  gap: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-decoration: none;
  line-height: 22px;

  &:hover {
    background-color: #27272a;
  }
`;

export const WrapperProfile = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 1.5rem;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Username = styled.p`
  margin: 0;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  flex: 1;
  font-size: 16px;
`;

export const RecentChatItem = styled.div`
  margin: 0;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  flex-shrink: 0;

  &:hover {
    background-color: #27272a;
  }
`;

export const RecentChats = styled.div`
  margin: 0 -8px;
  gap: 4px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  overflow-y: auto;
  padding-right: 4px;
  width: 100%;
  height: 100%;
  /* Hide default scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #1a1924; /* Track color */
    border: 1px solid #242424;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #333333; /* Thumb color */
    border-radius: 10px; /* Rounded edges */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #363636; /* Color on hover */
  }

  /* Optional: Add a custom arrow */
  &::-webkit-scrollbar-corner {
    background: transparent; /* Corner color */
  }

  @media (max-width: 768px) {

    & > *:last-child {
      padding-bottom: 2rem;
    }
  }
`;
